import React, {Component} from 'react';
import ReactDOM from "react-dom";
import Loader from "../Loader";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt_BR from 'date-fns/locale/pt-BR';
import AsyncSelect from 'react-select/async';
import Select from "react-select";
import transform from '../../services/RelatorioAcompanhamentoService';
import TableRelatorioAcompanhamento from './TableRelatorioAcompanhamento';
import TableRelatorioAcompanhamentoDinamico from './TableRelatorioAcompanhamentoDinamico';
import {Accordion, Button, Card} from "react-bootstrap";
import {Toast} from 'primereact/toast';
import exportData from './Excel';
import {useCopyTable} from '../../util/useCopyTable';

registerLocale('pt-BR', pt_BR);

let reportsServiceBaseUrl = import.meta.env.VITE_BASE_URL_REPORTS;


export default class RelatorioAcompanhamentoForm extends Component {

    defaultTiposOptions = [
        { label: 'Vertical', value: 'Vertical' },
        { label: 'Horizontal', value: 'Horizontal' },
        { label: 'Comercial', value: 'Comercial' },
        { label: 'Hotel', value: 'Hotel' }
    ];

    /**
     * Campos que possuem feedback inline no formulário. Erros de validação com
     * chave fora desta lista são exibidos no Toast, para que nenhuma mensagem
     * do serviço de relatórios se perca.
     */
    camposComFeedback = [
        'periodo_inicial', 'periodo_final', 'data_lancamento_inicial', 'data_lancamento_final',
        'tipos', 'padrao', 'tempo_de_venda', 'estados', 'cidades', 'bairros',
        'clustersCidades', 'clusters', 'tipo_detalhamento', 'estagio', 'agrupamento',
        'detalhes_para_exibir'
    ];

    /**
     * Reduz a chave a letras e dígitos minúsculos para casar os nomes em camelCase
     * devolvidos pelo serviço (tipoDetalhamento) com os do formulário (tipo_detalhamento).
     */
    chaveCanonica = (chave) => chave.replace(/_/g, '').toLowerCase();

    /**
     * Separa os erros de validação entre os que têm campo correspondente no
     * formulário e os que não têm.
     *
     * @returns {{porCampo: Object, semCampo: string[]}}
     */
    mapearErrosParaCampos = (errors) => {
        let camposPorChave = {};

        this.camposComFeedback.forEach(campo => {
            camposPorChave[this.chaveCanonica(campo)] = campo;
        });

        let porCampo = {};
        let semCampo = [];

        Object.keys(errors).forEach(chave => {
            let campo = camposPorChave[this.chaveCanonica(chave)];
            let mensagens = Array.isArray(errors[chave]) ? errors[chave] : [errors[chave]];

            if (campo) {
                porCampo[campo] = mensagens;
            } else {
                semCampo = semCampo.concat(mensagens);
            }
        });

        return { porCampo, semCampo };
    }

    /**
     * Exibe no Toast os erros que não têm campo correspondente no formulário.
     */
    mostrarErro = (detail) => {
        this.toast?.show({
            severity: 'error',
            summary: 'Erro',
            detail: detail,
            life: 9000
        });
    }


    constructor(props) {
        super();

        this.state = {
            periodo_inicial: '',
            data_lancamento_inicial: '',
            periodo_final: '',
            data_lancamento_final: '',
            tempo_de_venda: '',
            tipos: this.defaultTiposOptions.filter(tipo => tipo.value != 'Hotel'),
            estagio: [],
            estados: [],
            cidadesOptions: [],
            cidades: [],
            bairros: [],
            clusters: [],
            incorporadoras: [],
            tipo_detalhamento: [],
            padrao: [],
            projeto: [],
            agrupamento: {
                label: 'Mensal', value: 'Mensal'
            },
            detalhes_para_exibir: [],
            detalhes_para_exibir_buscados: [],
            tiposOptions: this.defaultTiposOptions,
            estadosOptions: [],
            errors: [],
            clusterOptions: [],
            incorporadorasOptions: [],
            loading: false,
            periodos: [],
            periodos_variacao: [],
            clustersCidades: [],
            clusterCidadesOptions: [],

            padraoOptions: [
                { 'label': 'Alto', value: 'Alto' },
                { 'label': 'Alto +', value: 'Alto +' },
                { 'label': 'Condomínio de Casas/Sobrados', value: 'Condomínio de Casas/Sobrados' },
                { 'label': 'Condomínio de Chácaras', value: 'Condomínio de Chácaras' },
                { 'label': 'Econômico', value: 'Econômico' },
                { 'label': 'Compacto', value: 'Compacto' },
                { 'label': 'Loteamento Aberto', value: 'Loteamento Aberto' },
                { 'label': 'Loteamento Comercial', value: 'Loteamento Comercial' },
                { 'label': 'Loteamento Fechado', value: 'Loteamento Fechado' },
                { 'label': 'Médio', value: 'Médio' },
                { 'label': 'Médio-Alto', value: 'Médio-Alto' },
                { 'label': 'Própria', value: 'Própria' },
                { 'label': 'Standard', value: 'Standard' },
                { 'label': 'Super Econômico', value: 'Super Econômico' },
                { 'label': 'Luxo', value: 'Luxo' },
                { 'label': 'Terreno', value: 'Terreno' }
            ],
            padroesPorTipo: {
                vertical: [
                    { label: 'Compacto', value: 'Compacto' },
                    { label: 'Econômico', value: 'Econômico' },
                    { label: 'Standard', value: 'Standard' },
                    { label: 'Médio', value: 'Médio' },
                    { label: 'Médio-Alto', value: 'Médio-Alto' },
                    { label: 'Alto', value: 'Alto' },
                    { label: 'Luxo', value: 'Luxo' },
                ],
                comercial: [
                    { label: 'Econômico', value: 'Econômico' },
                    { label: 'Standard', value: 'Standard' },
                    { label: 'Médio', value: 'Médio' },
                    { label: 'Alto', value: 'Alto' },
                    { label: 'Alto +', value: 'Alto +' },
                ]
                ,
                horizontal: [
                    { label: 'Condomínio de Casas/Sobrados', value: 'Condomínio de Casas/Sobrados' },
                    { label: 'Loteamento Fechado', value: 'Loteamento Fechado' },
                    { label: 'Condomínio de Chácaras', value: 'Condomínio de Chácaras' },
                    { label: 'Loteamento Aberto', value: 'Loteamento Aberto' },
                    { label: 'Loteamento Comercial', value: 'Loteamento Comercial' },
                    { label: 'Compacto', value: 'Compacto' },
                    { label: 'Econômico', value: 'Econômico' },
                    { label: 'Standard', value: 'Standard' },
                    { label: 'Médio', value: 'Médio' },
                    { label: 'Médio-Alto', value: 'Médio-Alto' },
                    { label: 'Alto', value: 'Alto' },
                    { label: 'Luxo', value: 'Luxo' }
                ]
            },
            agrupamentoOptions: [
                { label: 'Mensal', value: 'Mensal' },
                { label: 'Trimestre', value: 'Trimestre' },
                { label: 'Semestre', value: 'Semestre' },
                { label: 'Anual', value: 'Anual' }
            ],
            estagioOptions: [
                { label: "Planta", value: "Planta" },
                { label: "Construção", value: "Construção" },
                { label: "Pronto", value: "Pronto" }
            ],
            detalhesParaExibirOptions: [
                {
                    label: 'Lançamentos', options: [
                        { label: 'Empreendimentos Lançados', value: 'empreendimentos_lancados' },
                        { label: 'Unidades Lançadas', value: 'unidades_lancadas' },
                        { label: 'VGV Lançado', value: 'vgv_unidades_lancadas' }
                    ]
                },
                {
                    label: 'Vendas', options: [
                        { label: 'Empreendimentos Vendidos', value: 'empreendimentos_vendidos' },
                        { label: 'Unidades Vendidas Bruto', value: 'unidades_vendidas_bruto' },
                        { label: 'Unidades Vendidas Líquido', value: 'unidades_vendidas_liquido' },
                        { label: 'Unidades Distratadas', value: 'unidades_distratadas' },
                        { label: 'VGV Unidades Vendidas Bruto', value: 'vgv_unidades_vendidas_bruto' },
                        { label: 'VGV Unidades Vendidas Líquido', value: 'vgv_unidades_vendidas_liquido' },
                        { label: 'VGV Unidades Distratadas', value: 'vgv_unidades_distratadas' },
                        { label: 'IVV - Indice de Velocidade de Vendas', value: 'ivv' }
                    ]
                },
                {
                    label: 'Área', options: [
                        { label: 'Área Privativa Mínima', value: 'area_privativa_minima' },
                        { label: 'Área Privativa Máxima', value: 'area_privativa_maxima' },
                        { label: 'Área Privativa Média', value: 'area_privativa_media' }
                    ]
                },
                {
                    label: "Preços", options: [
                        { label: "Preço Médio", value: "preco_medio" },
                        { label: "Preço m² Médio", value: "preco_metro_medio" },
                        { label: "Preço m² Mínimo", value: "preco_metro_minimo" },
                        { label: "Preço m² Máximo", value: "preco_metro_maximo" }
                    ]
                },
                {
                    label: "Oferta Lançada", options: [
                        { label: "Oferta Lançada", value: "oferta_lancada" },
                        { label: "VGV Oferta Lançada", value: "vgv_oferta_lancada" },
                        { label: "Empreendimentos Ativos", value: "empreendimentos_ativos" }
                    ]
                },
                {
                    label: "Oferta Final", options: [
                        { label: "Oferta Final", value: "oferta_final" },
                        { label: "VGV Oferta Final", value: "vgv_oferta_final" },
                    ]
                },
                {
                    label: "Esgotados", options: [
                        { label: "Empreendimentos Esgotados", value: "empreendimentos_esgotados" },
                        { label: "Unidades Esgotadas", value: "unidades_esgotadas" }
                    ]
                },
                {
                    label: "Forma de Pagamento", options: [
                        { label: "Percentual de Entrada", value: "avg_porcentagem_entrada" },
                        { label: "Valor de Entrada", value: "avg_valor_entrada" },
                        { label: "Número de Parcelas", value: "avg_numero_parcela" },
                        { label: "Valor da Parcela", value: "avg_valor_parcela" },
                        { label: "Taxa Associativa", value: "avg_taxa_associativa" },
                        { label: "Percentual de Desconto", value: "avg_percentual_desconto" }
                    ]
                }],

            bairrosOptions: [],
            tipoDetalhamentoOptions: [
                { label: 'Padrão', value: 'Padrão' },
                { label: 'Tipo', value: 'Tipo' },
                { label: 'Bairro', value: 'Bairro' },
                { label: 'Cluster Cidade', value: 'ClusterCidade' },
                { label: 'Cluster Bairro', value: 'Cluster' },
                { label: 'Cidade', value: 'Cidade' },
                { label: 'Tipologia', value: 'Tipologia' },
                { label: 'Incorporadora', value: 'Incorporadora' },
                { label: 'Ano de Lançamento', value: 'Ano de Lançamento' },
                { label: 'Estágio de Obra e Padrão', value: 'Estágio de Obra e Padrão' },
                { label: 'Estágio de Obra e Tipo', value: 'Estágio de Obra e Tipo' },
                { label: 'Estado', value: 'Estado' },
                { label: 'Região', value: 'Região' },

            ],
            variacaoOptions: [
                { label: "Não Mostrar", value: "" },
                { label: "Mesmo Período do Ano anterior", value: "period_ano_anterior" },
                { label: "Período Imediatamente Anterior", value: "periodo_imediatamente_anterior" }


            ],
            tempo_de_venda_options: [
                { label: 'Até 6 meses', value: 'Até 6 meses', },
                { label: 'De 6 a 24 meses', value: 'De 6 a 24 meses', },
                { label: 'De 24 a 48 meses', value: 'De 24 a 48 meses', },
                { label: 'Acima de 48 meses', value: 'Acima de 48 meses', }
            ],
            variacao: '',
            rows: [],
            submited: false,
            cidades_monitoradas: null,
            cidades_alelo: null,
            cidades_cbic: null,
            regioes: [],
            sim_nao_options: [
                { label: 'Selecione', value: null },
                { label: 'Sim', value: 1 },
                { label: 'Não', value: 0 }
            ],
            projetos_options: [
                { label: 'ADU', value: 'adu' },
                { label: 'AELO', value: 'aelo' },
                { label: 'AELO-SP', value: 'pertence_projeto_alelo' },
                { label: 'CBIC', value: 'cbic' },
            ],
            regioes_options: [
                { label: 'Norte', value: 'Norte' },
                { label: 'Nordeste', value: 'Nordeste' },
                { label: 'Centro-Oeste', value: 'Centro-Oeste' },
                { label: 'Sudeste', value: 'Sudeste' },
                { label: 'Sul', value: 'Sul' }
            ],

            buscaIncorporadorasDefaultOptions: []


        }
    }

    getRequestHeader = () => {
        return {
            headers: {
                Authorization: `Bearer ${this.state.user.jwt_token}`
            }
        }
    }


    loadData = async () => {

        let requestExtraParams = {};

        try {

            await this.setState({
                ...this.state, errors: [],
            })

            await this.setLoading(true);


        } catch (e) {
            if (e.response && e.response.status === 422) {

                if (e.response.headers['content-type'] === 'application/json') {

                    let errors = e.response.data.errors;

                    if (requestExtraParams.responseType === 'blob') {
                        let responseBody = JSON.parse(await e.response.data.text());
                        errors = responseBody.errors;
                    }

                    this.setState({
                        ...this.state, errors: errors
                    });
                }
            }

            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    onChangeRegioes = async (e) => {
        let value = e;

        if (e === null) {
            value = [];
        }

        await this.setState({
            ...this.state, regioes: value
        });

        this.loadEstados();
    }

    setLoading = async (loading) => {

        await this.setState({
            loading: loading
        });
    }

    loadAuthUser = async () => {
        try {

            let response = await axios.get(route('user.auth'));

            if (response.status === 200) {
                this.setState({
                    ...this.state, user: response.data
                });
            }

        } catch (e) {
            console.log(e);
        }
    }

    loadEstados = async () => {
        try {



            let regioes = this.state.regioes?.map(regiao => regiao.value) || [];

            let response = await axios.get(route('web.todos_estados.index', {
                regioes: regioes
            }));

            if (response.status === 200) {
                this.setState({
                    ...this.state, estadosOptions: response.data
                });
            }

        } catch (e) {
            console.log(e);
        }
    }

    loadCidades = async () => {
        try {

            if (this.state.estados.length === 0) {
                return;
            }

            await this.setLoading(true);

            let siglasEstados = this.state.estados.map(estado => estado.value);


            let response = await axios.post(route('web.cidades_por_estado.index'), {
                estados: siglasEstados
            });

            if (response.status === 200) {
                this.setState({
                    ...this.state,
                    cidadesOptions: [
                        { value: "Todos", label: "Selecionar Todos" },
                        ...response.data
                    ]
                });
            }

            if (this.state.tipo_detalhamento?.value == "Estado") {
                let value = [];
                this.state.cidadesOptions.map((index) => {
                    if (index.options != undefined) {
                        value = value.concat(index.options)
                    }
                })
                await this.setState({
                    ...this.state,
                    cidades: value
                });
            }

        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    loadRegioesAdministrativas = async () => {
        if (this.state.estados.length === 0) {
            return;
        }

        try {
            await this.setLoading(true);

            let siglasEstados = this.state.estados.map(estado => estado.value);

            let response = await axios.post(route('web.regioes_administrativas_por_estado.index'), {
                estados: siglasEstados
            });

            if (response.status === 200) {

                this.setState({
                    ...this.state, regioesAdministrativasOptions: response.data
                });
            }
        } catch (e) {
            console.log(e);
        } finally {

        }
    }

    loadCidadesFromAdministrativas = async () => {
        try {
            if (this.state.regioesAdministrativas == undefined || this.state.regioesAdministrativas == "") {
                return;
            }

            this.setLoading(true);

            let cidades = await axios.post(route('web.cidades-regioes-administrativas.index'), {
                regiao: this.state.regioesAdministrativas.value
            });

            let value = []

            this.state.cidadesOptions.map((index) => {
                if (index.options != undefined) {
                    index.options.map((citidade) => {
                        if (cidades.data.includes(citidade.label)) {
                            value.push(citidade)
                        }
                    })
                }
            })

            await this.setState({
                ...this.state,
                cidades: value
            })
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.setLoading(false);
        }
    }

    loadBairros = async () => {
        try {

            if (this.state.cidades.length === 0) {
                return;
            }


            await this.setLoading(true);

            let cidades = this.state.cidades.map(cidade => cidade.value);

            let response = await axios.post(route('web.bairros_por_cidade.index'), {
                cidades: cidades
            });

            if (response.status === 200) {
                this.setState({
                    ...this.state, bairrosOptions: response.data
                });
            }

        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }


    loadClusters = async () => {
        if (this.state.cidades.length === 0) {
            return;
        }

        try {
            await this.setLoading(true);

            let cidades = this.state.cidades.map(cidade => cidade.value);

            let response = await axios.post(route('web.clusters_por_cidade.index'), {

                cidades: cidades
            });

            if (response.status === 200) {
                this.setState({
                    ...this.state, clusterOptions: response.data
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    loadClustersCidade = async () => {
        if (this.state.estados.length === 0) {
            return;
        }

        try {
            await this.setLoading(true);

            let estados = this.state.estados.map(estado => estado.value);

            let response = await axios.post(route('web.clusters_por_estado.index'), {

                estados: estados
            });

            if (response.status === 200) {
                this.setState({
                    ...this.state, clusterCidadesOptions: response.data
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    buscaIncorporadoras = async (query) => {

        try {

            if (query.length < 2) {
                return [];
            }

            let response = await axios.get(route('web.busca_incorporadoras.index'), {
                params: {
                    query: query
                }
            });

            if (response.status === 200) {
                await this.setState({ buscaIncorporadorasDefaultOptions: response.data })

                return response.data;
            }


        } catch (e) {
            console.log(e);
        } finally {

        }
    }


    componentDidMount = async () => {


        try {
            await Promise.all([this.loadAuthUser(), this.loadEstados(),]);

            //map options
            let detalhesLabel = {};

            for (let i = 0; i < this.state.detalhesParaExibirOptions.length; i++) {
                for (let j = 0; j < this.state.detalhesParaExibirOptions[i].options.length; j++) {
                    detalhesLabel[this.state.detalhesParaExibirOptions[i].options[j].value] = this.state.detalhesParaExibirOptions[i].options[j].label;
                }

            }

            this.setState({
                ...this.state, detalhesLabel: detalhesLabel
            });


        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Validação do formulário
     */
    validate = async () => {

        let errors = {};

        if (!this.state.periodo_inicial) {
            errors['periodo_inicial'] = ['O campo período inicial é obrigatório'];
        }


        if (!this.state.periodo_final) {
            errors['periodo_final'] = ['O campo período final é obrigatório'];
        }


        if (this.state.tipos.length === 0) {
            errors['tipos'] = ['O campo tipo é obrigatório'];
        }


        if (this.state.detalhes_para_exibir.length === 0) {
            errors['detalhes_para_exibir'] = ['O campo detalhes para exibir é obrigatório'];
        }


        if (this.state.tipo_detalhamento.length === 0) {
            errors['tipo_detalhamento'] = ['O campo tipo de detalhamento é obrigatório'];
        }

        if (Object.keys(errors).length > 0) {
            await this.setState({
                ...this.state,
                errors: errors
            });

            throw new Error('Validation Error');
        }


    }


    submit = async () => {

        /**
         * Distingue erro de validação no cliente (o relatório nem chegou a ser pedido)
         * de resposta vazia do serviço, para não exibir "Sem Informações para Exibir"
         * quando o problema é um campo obrigatório em branco.
         */
        let validado = false;

        try {

            await this.validate();

            validado = true;

            this.setState({
                ...this.state, errors: [], rows: []
            });

            let periods = await axios.post(route('web.periods_util.index'), {
                "periodo_inicial": this.state.periodo_inicial,
                "periodo_final": this.state.periodo_final,
                "tipo_periodo": this.state.agrupamento.value.toLowerCase(),
                "variacao": this.state.variacao?.value
            });

            if (periods.status === 200) {
                this.setState({
                    ...this.state, periodos: periods.data.periodos_normal, periodos_variacao: periods.data.periodos_variacao
                });
            }

            await this.setLoading(true);



            let payload = this.getPayloadForRequest();


            let rows = [];

            let [dataLancamentos, dataVendas, dataAreas, dataPrecos, dataPrecosMetro, dataOfertaLancada,
                dataOfertaFinal, dataUnidadesEsgotadas, dataEmpreendimentosEsgotados, dataIvv, dataPagamentos
            ] = await Promise.all([
                this.getLancamentos(payload),
                this.getVendas(payload),
                this.getAreas(payload),
                this.getPrecos(payload),
                this.getPrecosMetros(payload),
                this.getOfertaLancada(payload),
                this.getOfertaFinal(payload),
                this.getUnidadesEsgotadas(payload),
                this.getEmpreendimentosEsgotados(payload),
                this.getIvv(payload),
                this.getPagamentos(payload)
            ]);

            rows = dataLancamentos
                .concat(dataVendas)
                .concat(dataAreas)
                .concat(dataPrecos)
                .concat(dataPrecosMetro)
                .concat(dataOfertaLancada)
                .concat(dataOfertaFinal)
                .concat(dataUnidadesEsgotadas)
                .concat(dataEmpreendimentosEsgotados)
                .concat(dataIvv)
                .concat(dataPagamentos);


            this.setState({
                ...this.state,
                rows: rows,
                response_period_type: this.state.agrupamento.value.toLowerCase(),
                response_tipo_detalhamento: payload.tipo_detalhamento,
                response_variacao: payload.variacao,
                submited: true
            });


        } catch (e) {
            console.log(e);

            if (!validado) {
                //validate() já preencheu this.state.errors com o feedback por campo
                return;
            }

            let errors = e.response?.status === 422 ? e.response.data?.errors : null;

            //setState parcial: espalhar this.state aqui poderia sobrescrever os erros
            //gravados por validate() com uma leitura defasada do estado
            if (!errors) {
                this.setState({ errors: [] });

                this.mostrarErro('Não foi possível gerar o relatório. Revise os filtros informados e tente novamente.');

                return;
            }

            //o serviço devolve as chaves em camelCase (tipoDetalhamento) enquanto o
            //formulário renderiza o feedback em snake_case (tipo_detalhamento)
            let { porCampo, semCampo } = this.mapearErrosParaCampos(errors);

            this.setState({ errors: porCampo });

            if (semCampo.length > 0) {
                this.mostrarErro(semCampo.join(' '));
            }

        } finally {
            this.setLoading(false);
            this.setState({ submited: validado });
        }
    }


    getLancamentos = async (payload) => {

        let lancamentosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Lançamentos')[0].options;

        //paylod precisa ter pelo menos uma das opções de lançamentos para fazer o request
        if (payload.detalhes_para_exibir.filter(detalhe => lancamentosOptions.map(option => option.value).includes(detalhe)).length > 0) {

            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/lancamentos`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {

                let optionsLancamentos = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Lançamentos')[0].options.map(option => option.value);
                let detalhes = optionsLancamentos.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);

                return rows;
            }
        }

        return [];

    }


    getOfertaLancada = async (payload) => {

        let ofertaLancadaOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Oferta Lançada')[0].options;

        //paylod precisa ter pelo menos uma das opções de lançamentos para fazer o request
        if (payload.detalhes_para_exibir.filter(detalhe => ofertaLancadaOptions.map(option => option.value).includes(detalhe)).length > 0) {

            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/ofertas-lancada`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let optionsOfertaLancada = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Oferta Lançada')[0].options.map(option => option.value);
                let detalhes = optionsOfertaLancada.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);


                return rows;
            }
        }

        return [];
    }

    getOfertaFinal = async (payload) => {

        let ofertaFinalOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Oferta Final')[0].options;

        //paylod precisa ter pelo menos uma das opções de lançamentos para fazer o request
        if (payload.detalhes_para_exibir.filter(detalhe => ofertaFinalOptions.map(option => option.value).includes(detalhe)).length > 0) {

            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/ofertas-final`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                debugger;
                let optionsOfertaFinal = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Oferta Final')[0].options.map(option => option.value);
                let detalhes = optionsOfertaFinal.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let data = [...response.data];

                //se agrupamento não é mensal e o não existe linha para algum ano, repetir dados do último ano disponível
                if(payload.agrupamento !== 'Mensal' && response.data.length > 0 && response.data.length !== periodos.length) {
                    let periodosExistentes = response.data.map(item => item.periodo);
                    let lastRow = data[data.length -1];

                    for(let i = 0; i < periodos.length; i++) {
                        if(!periodosExistentes.includes(periodos[i].toString())) {
                            let newRow = { ...lastRow };
                            newRow.periodo = periodos[i].toString();
                            data.push(newRow);
                        }
                    }
                }

                return transform(data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);
            }
        }

        return [];
    }

    getPagamentos = async (payload) => {


        let pagamentosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Forma de Pagamento')[0].options;

        if (payload.detalhes_para_exibir.filter(detalhe => pagamentosOptions.map(option => option.value).includes(detalhe)).length > 0) {

            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/pagamentos`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {

                let optionsPagamentos = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Forma de Pagamento')[0].options.map(option => option.value);
                let detalhes = optionsPagamentos.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);

                return rows;

            }
        }

        return [];
    }


    getVendas = async (payload) => {


        let vendasOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Vendas')[0].options;

        //retira o ivv de options pois ele é obtido em um request separado para outro endpoint
        vendasOptions = vendasOptions.filter(option => option.value !== 'ivv');

        if (payload.detalhes_para_exibir.filter(detalhe => vendasOptions.map(option => option.value).includes(detalhe)).length > 0) {

            payload = { ...payload, detalhes_para_exibir: payload.detalhes_para_exibir.filter(detalhe => detalhe !== 'ivv') }

            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/vendas`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let optionsVendas = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Vendas')[0].options.map(option => option.value).filter(option => option !== 'ivv');
                let detalhes = optionsVendas.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);
                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);

                return rows;
            }
        }

        return [];
    }

    getIvv = async (payload) => {


        let ivvOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Vendas')[0].options.filter(option => option.value === 'ivv');        //pega somente o ivv de options

        if (payload.detalhes_para_exibir.filter(detalhe => ivvOptions.map(option => option.value).includes(detalhe)).length > 0) {

            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/ivv`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let detalhes = ivvOptions.map(option => option.value).filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));
                let periodos = this.state.periodos.concat(this.state.periodos_variacao);
                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);
                return rows;
            }
        }

        return [];
    }

    getPrecos = async (payload) => {
        let precosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Preços')[0].options.filter(option => option.value == 'preco_medio');

        if (payload.detalhes_para_exibir.filter(detalhe => precosOptions.map(option => option.value).includes(detalhe)).length > 0) {

            payload = { ...payload, detalhes_para_exibir: payload.detalhes_para_exibir.filter(detalhe => detalhe == 'preco_medio') }
            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/precos`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let precosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Preços')[0].options.map(option => option.value);
                let detalhes = precosOptions.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);


                return rows;
            }
        }

        return [];

    }


    getPrecosMetros = async (payload) => {

        let precosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Preços')[0].options.filter(option => option.value != 'preco_medio');

        if (payload.detalhes_para_exibir.filter(detalhe => precosOptions.map(option => option.value).includes(detalhe)).length > 0) {
            let headers = this.getRequestHeader();
            payload = { ...payload, detalhes_para_exibir: payload.detalhes_para_exibir.filter(detalhe => detalhe != 'preco_medio') }
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/precos-metro`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let precosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Preços')[0].options.map(option => option.value);
                let detalhes = precosOptions.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);


                return rows;
            }
        }

        return [];

    }


    getUnidadesEsgotadas = async (payload) => {
        let esgotadosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Esgotados')[0].options.filter(option => option.value == 'unidades_esgotadas');

        //paylod precisa ter pelo menos uma das opções de vendas para fazer o request
        if (payload.detalhes_para_exibir.filter(detalhe => esgotadosOptions.map(option => option.value).includes(detalhe)).length > 0) {
            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/esgotados`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let optionsEsgotados = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Esgotados')[0].options.map(option => option.value).filter(option => option == 'unidades_esgotadas');
                let detalhes = optionsEsgotados.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);

                return rows;
            }
        }

        return [];
    }

    getEmpreendimentosEsgotados = async (payload) => {
        let esgotadosOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Esgotados')[0].options.filter(option => option.value == 'empreendimentos_esgotados');

        //paylod precisa ter pelo menos uma das opções de vendas para fazer o request
        if (payload.detalhes_para_exibir.filter(detalhe => esgotadosOptions.map(option => option.value).includes(detalhe)).length > 0) {
            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/empreendimentos-esgotados`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let optionsEsgotados = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Esgotados')[0].options.map(option => option.value).filter(option => option == 'empreendimentos_esgotados');
                let detalhes = optionsEsgotados.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);

                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);

                return rows;
            }
        }

        return [];

    }


    getAreas = async (payload) => {
        let areasOptions = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Área')[0].options;

        //paylod precisa ter pelo menos uma das opções de vendas para fazer o request
        if (payload.detalhes_para_exibir.filter(detalhe => areasOptions.map(option => option.value).includes(detalhe)).length > 0) {
            let headers = this.getRequestHeader();
            let response = await axios.post(`${reportsServiceBaseUrl}/bases-report/areas`, payload, headers);

            if (response.status === 200 && response.data.length > 0) {
                let optionsAreas = this.state.detalhesParaExibirOptions.filter(detalhe => detalhe.label === 'Área')[0].options.map(option => option.value);
                let detalhes = optionsAreas.filter(detalhe => payload.detalhes_para_exibir.includes(detalhe));

                let periodos = this.state.periodos.concat(this.state.periodos_variacao);
                let rows = transform(response.data, detalhes, periodos, payload.tipos, payload.tipo_detalhamento);


                return rows;
            }
        }

        return [];
    }

    getPayloadForRequest = () => {

        let payload = {};

        payload.periodo_inicial = this.state.periodo_inicial;
        payload.periodo_final = this.state.periodo_final;

        payload.data_lancamento_inicial = this.state.data_lancamento_inicial;
        payload.data_lancamento_final = this.state.data_lancamento_final;

        payload.tempoDeVenda = this.state.tempo_de_venda?.value;
        payload.tipos = this.state.tipos.map(tipo => tipo.value);
        payload.estagio = this.state.estagio.map(estagio => estagio.value);
        payload.estados = this.state.estados.map(estado => estado.value);
        payload.cidades = this.state.cidades.map(cidade => cidade.value);
        payload.bairros = this.state.bairros.map(bairro => bairro.value);
        payload.clusters = this.state.clusters.map(cluster => cluster.value);
        payload.clustersCidades = this.state.clustersCidades.map(cluster => cluster.value);
        payload.incorporadoras = this.state.incorporadoras.map(incorporadora => incorporadora.value);
        payload.tipo_detalhamento = this.state.tipo_detalhamento.map((tipo_detalhamento) => tipo_detalhamento.value).toString();
        payload.padrao = this.state.padrao.map(padrao => padrao.value);
        if (payload.padrao && payload.padrao.includes('Condomínio de Casas/Sobrados')) {
            let padroesCasa = ['Econômico', 'Standard', 'Médio', 'Médio-Alto', 'Alto', 'Luxo'];
            padroesCasa.map((index) => {
                if (!payload.padrao.includes(index)) { payload.padrao.push(index) }
            })
        }
        payload.agrupamento = this.state.agrupamento.value;
        payload.detalhes_para_exibir = this.state.detalhes_para_exibir.map(detalhe => detalhe.value);
        payload.variacao = this.state.variacao?.value;
        payload.cidades_monitoradas = this.state.cidades_monitoradas?.value;
        payload.cidades_alelo = this.state.cidades_alelo?.value;
        payload.cidades_cbic = this.state.cidades_cbic?.value;
        payload.regioes = this.state.regioes.map(regiao => regiao.value);
        payload.projetos = this.state.projeto?.map(projeto => projeto.value)

        this.setState({
            ...this.state,
            detalhes_para_exibir_buscados: this.state.detalhes_para_exibir
        })

        return payload;
    }


    render() {

        return (<div className="card">
            {this.state.loading && <Loader />}

            {/* fora do Accordion para continuar montado mesmo com o formulário recolhido */}
            <Toast ref={(el) => this.toast = el} position="top-right" />

            <Accordion defaultActiveKey="0">
                <Card>
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                            Relatório de Acompanhamento
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <form action="">
                                <div className="form-group row">
                                    <div className="col-3">

                                        <label htmlFor="status">Período Inicial</label> <br />
                                        <DatePicker
                                            locale="pt-BR"
                                            name="periodo_inicial"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthYearPicker
                                            autoComplete="off"
                                            selected={this.state.periodo_inicial}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, periodo_inicial: e
                                                });
                                            }}
                                        />
                                        {this.state.errors['periodo_inicial'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['periodo_inicial'][0]}
                                            </div>}

                                    </div>
                                    <div className="col-3">

                                        <label htmlFor="status">Período Final</label> <br />
                                        <DatePicker
                                            locale="pt-BR"
                                            name="periodo_final"
                                            autoComplete="off"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthYearPicker
                                            selected={this.state.periodo_final}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, periodo_final: e
                                                });
                                            }}
                                        />
                                        {this.state.errors['periodo_final'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['periodo_final'][0]}
                                            </div>}

                                    </div>

                                    <div className="col-3">

                                        <label htmlFor="status">Data de Lançamento Inicial</label> <br />
                                        <DatePicker
                                            locale="pt-BR"
                                            name="data_lancamento_inicial"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthYearPicker
                                            autoComplete="off"
                                            selected={this.state.data_lancamento_inicial}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, data_lancamento_inicial: e
                                                });
                                            }}
                                        />
                                        {this.state.errors['data_lancamento_inicial'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['data_lancamento_inicial'][0]}
                                            </div>}

                                    </div>
                                    <div className="col-3">

                                        <label htmlFor="status">Data de Lançamento Final</label> <br />
                                        <DatePicker
                                            locale="pt-BR"
                                            name="data_lancamento_final"
                                            autoComplete="off"
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            showMonthYearPicker
                                            selected={this.state.data_lancamento_final}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, data_lancamento_final: e
                                                });
                                            }}
                                        />
                                        {this.state.errors['data_lancamento_final'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['data_lancamento_final'][0]}
                                            </div>}

                                    </div>

                                </div>

                                <div className='form-group row'>
                                    <div className="col-4">
                                        <label htmlFor="status">Tipo</label>
                                        <Select
                                            isMulti
                                            name="tipo"
                                            closeMenuOnSelect={false}
                                            options={this.state.tiposOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione os Tipos"
                                            value={this.state.tipos}
                                            onChange={async (e) => {

                                                let padroesPorTipo = e.reduce((acc, tipo) => {
                                                    return acc.concat(this.state.padroesPorTipo[tipo.value.toLowerCase()] || []);
                                                }, []);

                                                padroesPorTipo = padroesPorTipo.filter((obj, index, self) =>
                                                    index === self.findIndex(o => JSON.stringify(o) === JSON.stringify(obj))
                                                );

                                                await this.setState({
                                                    ...this.state,
                                                    tipos: e || [],
                                                    padraoOptions: padroesPorTipo
                                                });

                                                console.log(this.state.padraoOptions, padroesPorTipo);


                                            }}></Select>

                                        {this.state.errors['tipos'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['tipos'][0]}
                                            </div>}
                                    </div>
                                    <div className="col-4">
                                        <label htmlFor="status">Padrão</label>
                                        <Select
                                            name="padrao"
                                            isMulti
                                            options={this.state.padraoOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione o padrão"
                                            value={this.state.padrao}
                                            onChange={async (e) => {
                                                let value = e;

                                                if (e === null) {
                                                    value = [];
                                                }


                                                await this.setState({
                                                    ...this.state, padrao: value
                                                });
                                            }}></Select>

                                        {this.state.errors['padrao'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['padrao'][0]}
                                            </div>}
                                    </div>
                                    <div className="col-4">
                                        <label htmlFor="status">Tempo de Venda</label>
                                        <Select
                                            name="padrao"
                                            isMulti={false}
                                            options={this.state.tempo_de_venda_options}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione o Tempo de Venda"
                                            value={this.state.tempo_de_venda}
                                            onChange={async (e) => {
                                                let value = e;

                                                if (e === null) {
                                                    value = [];
                                                }


                                                await this.setState({
                                                    ...this.state, tempo_de_venda: value
                                                });
                                            }}></Select>

                                        {this.state.errors['tempo_de_venda'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['tempo_de_venda'][0]}
                                            </div>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-3">
                                        <label htmlFor="regiao">Região</label>
                                        <Select name="regiao"
                                            isMulti
                                            options={this.state.regioes_options}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione as Regiões"
                                            value={this.state.regioes}
                                            onChange={this.onChangeRegioes}></Select>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="status">Estado</label>
                                        <Select
                                            name="estado"
                                            closeMenuOnSelect={false}
                                            isMulti
                                            options={this.state.estadosOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Todos"
                                            value={this.state.type}
                                            inputValue={this.state.inputEstadoValue ?? ""}
                                            onInputChange={(input) => {
                                                this.setState({ inputEstadoValue: input });
                                            }}
                                            filterOption={(option, input) => {
                                                if (!input) return true;

                                                const searchTerms = input.split(";").map(term => term.trim().toLowerCase());

                                                const lastTermIsEmpty = searchTerms[searchTerms.length - 1] === "";

                                                return searchTerms.some(term => lastTermIsEmpty ? option.label?.toLowerCase() == term : option.label?.toLowerCase().includes(term)
                                                );

                                            }}
                                            onChange={async (e) => {
                                                let value = e;

                                                if (e === null) {
                                                    value = [];
                                                }

                                                await this.setState({
                                                    ...this.state, estados: value
                                                });
                                                await this.loadClustersCidade();
                                                this.loadCidades();
                                                this.loadRegioesAdministrativas();
                                            }}></Select>

                                        {this.state.errors['estados'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['estados'][0]}
                                            </div>}
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="status">Cidades</label>
                                        <Select
                                            isDisabled={this.state.tipo_detalhamento?.some(item => item.value === 'Estado')}
                                            name="cidades"
                                            closeMenuOnSelect={false}
                                            isMulti
                                            options={this.state.cidadesOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione as cidades"
                                            value={this.state.cidades}
                                            inputValue={this.state.inputCidadeValue ?? ""}
                                            onInputChange={(input) => { this.setState({ inputCidadeValue: input }); }}
                                            filterOption={(option, input) => {
                                                if (!input) return true;

                                                const searchTerms = [];
                                                searchTerms.push('selecionar todos');

                                                input.split(";").map(term => searchTerms.push(term.trim().toLowerCase()))

                                                const lastTermIsEmpty = searchTerms[searchTerms.length - 1] === "";

                                                return searchTerms.some(term => lastTermIsEmpty ? option.label?.toLowerCase() == term : option.label?.toLowerCase().includes(term)
                                                );

                                            }}
                                            onChange={async (e) => {
                                                let value = e;

                                                if (e === null) {
                                                    value = [];
                                                }
                                                if (value.some(item => item.value === 'Todos')) {
                                                    value = [];

                                                    if (this.state.inputCidadeValue) {
                                                        const searchTerms = this.state.inputCidadeValue.split(";").map(term => term.trim().toLowerCase());

                                                        const lastTermIsEmpty = searchTerms[searchTerms.length - 1] === "";

                                                        this.state.cidadesOptions.map((index) => {
                                                            if (index.options !== undefined) {

                                                                let newOptions = index.options.filter((option) => lastTermIsEmpty ? searchTerms.some(term => option.label.toLowerCase() == term) : searchTerms.some(term => option.label.toLowerCase().includes(term)))
                                                                value = value.concat(newOptions)

                                                            }
                                                        })
                                                    }
                                                    else {
                                                        this.state.cidadesOptions.map((index) => {
                                                            if (index.options !== undefined) {
                                                                value = value.concat(index.options)
                                                            }
                                                        })
                                                    }
                                                }
                                                await this.setState({
                                                    ...this.state, cidades: value
                                                });

                                                await this.loadBairros();
                                                await this.loadClusters();
                                            }}></Select>

                                        {this.state.errors['cidades'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['cidades'][0]}
                                            </div>}
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="status">Bairros</label>
                                        <Select
                                            closeMenuOnSelect={false}
                                            isDisabled={this.state.tipo_detalhamento?.some(item => item.value === 'Estado')}
                                            name="bairros"
                                            isMulti
                                            options={this.state.bairrosOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione os Bairros"
                                            value={this.state.bairros}
                                            inputValue={this.state.inputBairroValue ?? ""}
                                            onInputChange={(input) => {
                                                this.setState({ inputBairroValue: input });
                                            }}
                                            filterOption={(option, input) => {
                                                if (!input) return true;

                                                const searchTerms = input.split(";").map(term => term.trim().toLowerCase());

                                                const lastTermIsEmpty = searchTerms[searchTerms.length - 1] === "";

                                                return searchTerms.some(term => lastTermIsEmpty ? option.label?.toLowerCase() == term : option.label?.toLowerCase().includes(term)
                                                );

                                            }}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, bairros: e || []
                                                });
                                            }}></Select>

                                        {this.state.errors['bairros'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['bairros'][0]}
                                            </div>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-3">
                                        <label htmlFor="monitoradas">Cidades Monitoradas</label>
                                        <Select
                                            name="cidades_monitoradas"

                                            options={this.state.sim_nao_options}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione"
                                            value={this.state.cidades_monitoradas}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, cidades_monitoradas: e
                                                });
                                            }}></Select>
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="monitoradas">Projeto</label>
                                        <Select
                                            name="projeto"
                                            isMulti
                                            options={this.state.projetos_options}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione"
                                            value={this.state.projeto}
                                            onChange={(e) => {
                                                this.setState({ ...this.state, projeto: e });
                                            }}></Select>
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="status">Cluster Cidades</label>
                                        <Select
                                            name="clustersCidades"
                                            isMulti
                                            options={[{ label: 'Selecionar Todos CBIC', value: 'cbic' }, { label: 'Selecionar Todos AELO', value: 'aelo' }, ...this.state.clusterCidadesOptions]}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione os Clusters"
                                            value={this.state.clustersCidades}
                                            onChange={async (e) => {
                                                let value = e || [];

                                                const hasCbicOrAelo = value.some(item => item.value === 'cbic' || item.value === 'aelo');

                                                if (hasCbicOrAelo) {
                                                    value = this.state.clusterCidadesOptions?.filter(cluster =>
                                                        value.some(item => cluster.label.toLowerCase().includes(item.value))
                                                    );
                                                }

                                                await this.setState({
                                                    clustersCidades: value || []
                                                });
                                            }}></Select>

                                        {this.state.errors['clustersCidades'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['clustersCidades'][0]}
                                            </div>}
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="status">Cluster Bairros</label>
                                        <Select
                                            name="cluster"
                                            isMulti
                                            options={[{ label: 'Selecionar Todos CBIC', value: 'cbic' }, { label: 'Selecionar Todos AELO', value: 'aelo' }, ...this.state.clusterOptions]}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione os Clusters"
                                            value={this.state.clusters}
                                            onChange={async (e) => {
                                                let value = e || [];

                                                const hasCbicOrAelo = value.some(item => item.value === 'cbic' || item.value === 'aelo');

                                                if (hasCbicOrAelo) {
                                                    value = this.state.clusterOptions?.filter(cluster =>
                                                        value.some(item => cluster.label.toLowerCase().includes(item.value))
                                                    );
                                                }

                                                await this.setState({
                                                    clusters: value || []
                                                });
                                            }}></Select>

                                        {this.state.errors['clusters'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['clusters'][0]}
                                            </div>}
                                    </div>
                                </div>
                                <div className="form-group row">

                                    <div className="col-4">
                                        <label htmlFor='regioes_administrativas'>Regiões Administrativas</label>
                                        <Select
                                            name="regioes_administrativas"
                                            options={this.state.regioesAdministrativasOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione as Regiões Administrativas"
                                            value={this.state.regioesAdministrativas}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, regioesAdministrativas: e || ''
                                                });
                                                this.loadCidadesFromAdministrativas()
                                            }}></Select>
                                    </div>
                                    <div className='col-4'>
                                        <label htmlFor='incorporadoras'>Incorporadoras</label>
                                        <AsyncSelect
                                            isMulti
                                            onMenuClose={() => this.setState({ buscaIncorporadorasDefaultOptions: [] })}
                                            closeMenuOnSelect={false}
                                            loadOptions={this.buscaIncorporadoras}
                                            defaultOptions={this.state.buscaIncorporadorasDefaultOptions}
                                            value={this.state.incorporadoras}
                                            onChange={async (e) => {
                                                let values = e;

                                                if (e === null) { values = []; }

                                                await this.setState({ ...this.state, incorporadoras: values });
                                            }}></AsyncSelect>
                                    </div>
                                    <div className="col-4">
                                        <label htmlFor="status">Tipo de Detalhamento</label>
                                        <Select
                                            name="tipo_detalhamento"
                                            isMulti
                                            options={this.state.tipoDetalhamentoOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione o tipo de detalhamento"
                                            value={this.state.tipo_detalhamento}
                                            onChange={async (e) => {
                                                let value = e;

                                                if (value === null) {
                                                    value = [];

                                                }

                                                if (value?.some(item => item.value === 'Estado')) {
                                                    let valueCidades = [];
                                                    this.state.cidadesOptions.map((index) => {
                                                        if (index.options != undefined) {
                                                            valueCidades = valueCidades.concat(index.options)
                                                        }
                                                    })
                                                    await this.setState({
                                                        ...this.state,
                                                        cidades: valueCidades
                                                    });
                                                }

                                                await this.setState({
                                                    ...this.state,
                                                    tipo_detalhamento: value,
                                                });

                                            }}></Select>

                                        {this.state.errors['tipo_detalhamento'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['tipo_detalhamento'][0]}
                                            </div>}
                                    </div>
                                </div>
                                <div className="row form-group">


                                    <div className="col-4">
                                        <label htmlFor="status">Estágio da Obra</label>
                                        <Select
                                            name="estagio"
                                            isMulti
                                            options={this.state.estagioOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione o Estágio da Obra"
                                            value={this.state.estagio}
                                            onChange={async (e) => {
                                                let value = e;

                                                if (e === null) {
                                                    value = [];
                                                }


                                                await this.setState({
                                                    ...this.state, estagio: value
                                                });
                                            }}></Select>

                                        {this.state.errors['estagio'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['estagio'][0]}
                                            </div>}
                                    </div>
                                    <div className='col-4'>
                                        <label htmlFor='agrupamento'>Agrupamento</label>
                                        <Select

                                            name="agrupamento"
                                            options={this.state.agrupamentoOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione o agrupamento"
                                            value={this.state.agrupamento}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, agrupamento: e
                                                });
                                            }}></Select>
                                        {this.state.errors['agrupamento'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['agrupamento'][0]}
                                            </div>}
                                    </div>

                                    <div className="col-4">
                                        <label>Variação</label>
                                        <Select
                                            name="variacao"
                                            options={this.state.variacaoOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione a variação"
                                            value={this.state.variacao}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    ...this.state, variacao: e
                                                });
                                            }}></Select>

                                    </div>

                                </div>

                                <div className="row form-group">
                                    <div className="col-12">
                                        <label htmlFor='detalhes_para_exibir'>Detalhes</label>
                                        <Select
                                            isMulti
                                            closeMenuOnSelect={false}
                                            name="detalhes_para_exibir"
                                            options={this.state.detalhesParaExibirOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecione os detalhes"
                                            value={this.state.detalhes_para_exibir}
                                            onChange={async (e) => {
                                                let value = e;
                                                if (e === null) {
                                                    value = [];

                                                }
                                                await this.setState({
                                                    ...this.state, detalhes_para_exibir: value
                                                });
                                            }}></Select>
                                        {this.state.errors['detalhes_para_exibir'] &&
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {this.state.errors['detalhes_para_exibir'][0]}
                                            </div>}

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <button className={"btn btn-primary button-brain btn-round btn-block"}
                                            onClick={async () => {
                                                await this.submit();
                                            }} type="button">Gerar Relatório
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>


            <div className="card">
                <div className="card-body">
                    <div style={{ overflowY: "auto" }}>
                        <div>
                            <p className="alert alert-info font-weight-bold">
                                <i className="fa fa-info-circle"></i> &nbsp;
                                Resultados de VGV são apresentados em mil R$.

                            </p>
                            <div className='row'>
                                <div className='col-3'>
                                    <button onClick={() => exportData(this.state.rows)} className="btn btn-success">
                                        <i className='fa fa-file-excel-o'></i> &nbsp;
                                        Download Excel
                                    </button>
                                    &nbsp;
                                    <button onClick={() => useCopyTable(`excel1`)} className="btn btn-success" disabled={this.state.rows.length == 0}>Copiar</button>
                                </div>
                            </div>
                        </div>
                        {this.state.rows.length > 0 && this.state.tipo_detalhamento.length == 1 && <TableRelatorioAcompanhamento
                            rows={this.state.rows}
                            tipo_detalhamento={this.state.response_tipo_detalhamento}
                            detalhesLabel={this.state.detalhesLabel}
                            response_period_type={this.state.response_period_type}
                            periodos={this.state.periodos}
                            setLoading={this.setLoading}
                            variacao={this.state.response_variacao}
                            periodos_variacao={this.state.periodos_variacao}
                            id={1}
                        />}

                        {this.state.rows.length > 0 && this.state.tipo_detalhamento.length > 1 && <TableRelatorioAcompanhamentoDinamico
                            rows={this.state.rows}
                            id={1}
                            tipo_detalhamento={this.state.response_tipo_detalhamento}
                            detalhesLabel={this.state.detalhesLabel}
                            detalhesSelecionados={this.state.detalhes_para_exibir_buscados}
                            response_period_type={this.state.response_period_type}
                            periodos={this.state.periodos}
                            setLoading={this.setLoading}
                            variacao={this.state.response_variacao}
                            periodos_variacao={this.state.periodos_variacao}
                        />}

                        {this.state.rows.length === 0 && this.state.submited && <p className="alert alert-info text-center font-weight-bold small">Sem Informações para Exibir</p>}
                    </div>
                </div>
            </div>

        </div >);
    }
}


if (document.getElementById('js-form-acompanhamento-report')) {
    ReactDOM.render(<RelatorioAcompanhamentoForm />, document.getElementById('js-form-acompanhamento-report'));
}
